import {
  ChannelMessagesState,
  PendingMessage,
  WebSocketConnectionStatus,
  WebSocketMessage,
} from './websocket.models';

export interface WebSocketState {
  connectionStatus: WebSocketConnectionStatus;
  connected: boolean;
  connecting: boolean;
  error: string | null;

  subscribedChannelIds: string[];

  messagesByChannel: Record<string, ChannelMessagesState>;

  /**
   * Global message dedupe across all channels.
   * Key format:
   *   server:<messageId>
   *   client:<clientMessageId>
   */
  messageDedupMap: Record<string, true>;

  /**
   * Temporary optimistic messages waiting for server echo/ack style matching.
   */
  pendingMessages: Record<string, PendingMessage>;

  /**
   * Optional presence / system events can also be shown in timeline.
   * We keep everything in the same message stream for simplicity.
   */
  lastEvent: string | null;
}

export const initialWebSocketState: WebSocketState = {
  connectionStatus: 'disconnected',
  connected: false,
  connecting: false,
  error: null,
  subscribedChannelIds: [],
  messagesByChannel: {},
  messageDedupMap: {},
  pendingMessages: {},
  lastEvent: null,
};